// $(document).ready(function () {
    let chatDemarre = false;
    let iframeChat;
    const boutonsDemarrerChat = document.querySelectorAll('.bouton-demarrer-chat');
    if (boutonsDemarrerChat) {
        boutonsDemarrerChat.forEach(boutonDemarrerChat => {
            boutonDemarrerChat.addEventListener('click', () => {
                if (!chatDemarre) {
                    chatDemarre = true;
                    // iframeChat = $('<iframe></iframe>', {
                    //     id: 'iframe-chat',
                    //     // class: 'd-none',
                    //     src: boutonDemarrerChat.dataset.urlChat,
                    // });
                    // iframeChat .appendTo($('body'));
                    // iframeChat.on('load', () => {
                    //     iframeChat.contents().find('.lien-fermer-selection-sujet-chat').click(e => {
                    //         e.preventDefault();
                    //         iframeChat.remove();
                    //         // boutonDemarrerChat.classList.remove('d-none');
                    //         chatDemarre = false;
                    //     });
                    //     // iframeChat.removeClass('d-none');
                    //     // boutonDemarrerChat.classList.add('d-none');
                    // });
                    iframeChat = document.createElement('iframe');
                    iframeChat.id = 'iframe-chat';
                    iframeChat.src = boutonDemarrerChat.dataset.urlChat;
                    document.body.appendChild(iframeChat);
                    iframeChat.addEventListener('load', () => {
                        // var link = iframeChat.contentDocument.querySelector('.lien-fermer-selection-sujet-chat');
                        var link = iframeChat.contentDocument.querySelector('.chat_lien-fermer');
                        if (link) {
                            link.addEventListener('click', e => {
                                e.preventDefault();
                                document.body.removeChild(iframeChat);
                                chatDemarre = false;
                            });
                        }
                    });
                } else {
                    if (iframeChat) {
                        // iframeChat.remove();
                        document.body.removeChild(iframeChat);
                    }
                    chatDemarre = false;
                }
            });
        });
    }
// });
